module.exports = __webpack_public_path__ + "img/e5358bd5a21bc1a09ced7797c4c22007.png";


//////////////////
// WEBPACK FOOTER
// ./classes/items/herbs/assets/sprites/herbs.png
// module id = 70
// module chunks = 0